export default 
{
  type: "form-url",
  style: "",
  data: {
    label: "New URL Field",
    placeholder: "https://www.radicasys.com",
  },
  children: [],
};
